import { addMuseum, removeMuseum } from "../constants/userConstant";

const museumData = {
  museumData: null,
};

const MuseumReducer = (state = museumData, action) => {
  switch (action.type) {
    case addMuseum:
      return { ...state, museumData: action.payload.museumDetails };
    case removeMuseum:
      return { ...state, museumData: null };
    default:
      return state;
  }
};

export default MuseumReducer;
